module.exports = __webpack_public_path__ + "img/c1.623d4097.jpg";